export default __webpack_public_path__ + "static/media/hec-logo.e15945d4.svg";